module.exports = __webpack_public_path__ + "img/isleofman.c1e8d8ee.svg";